<!--
    课程分享-课程批量授权-授权账号弹窗
    作用：第三步中的授权账号弹窗，授权账号数
    说明：版本3.0
-->
<template>
  <el-dialog
    title="授权账号"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    width="540px"
  >
    <div class="top-info">
      <span class="item">校区名称：{{ row.search_clients_name }}</span>
      <span class="item">校区代码：{{ row.search_clients_code }}</span>
    </div>
    <el-form ref="dataForm" :model="form" :rules="rules">
      <el-form-item label="课程上课次数限制（单位/次）：" prop="input">
        <el-input v-model="form.input"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitData">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { validateInteger } from '@/utils/validate'
export default {
  name: 'numDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    row: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      form: {
        input: 0
      },
      rules: {
        input: [
          { required: true, message: '请输入上课次数', trigger: 'blur' },
          { validator: validateInteger, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    const row = Object.assign(this.row)
    this.form.input = row.authCount
  },
  methods: {
    submitData () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const obj = {
            id: this.row.search_clients_id,
            school_name: this.row.search_clients_name,
            school_code: this.row.search_clients_code,
            auth_number: +this.form.input
          }
          const accountAuth = this.$store.state.accountAuth
          accountAuth.forEach((item, index) => {
            if (item.id === this.row.search_clients_id) {
              accountAuth.splice(index, 1)
            }
          })
          accountAuth.push(obj)
          this.$store.dispatch('setAccountAuth', accountAuth)
          this.$emit('close-dialog')
          this.$emit('change-data')
          console.log('setAccountAuth', this.$store.state.accountAuth)
        }
      })
    },
    handleClose () {
      this.$emit('close-dialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.top-info{
  display: flex;
  padding-bottom: 20px;
  .item{
   flex:1
  }
}
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/volumeAuth/components/numDialog.vue